/**
 * @author caijianjia
 * @date 2020/3/17 3:18 下午
 */

export const tableHead = [
  {
    prop: 'order',
    label: '排序',
    width: '180',
    filter: 'input',
    sortable: true
  },
  {
    prop: 'name',
    label: '课件名称',
    width: '180'
  },
  {
    prop: 'title',
    label: '课件标题',
    width: '180'
  },
  {
    prop: 'created_at',
    label: '创建时间',
    width: '168'
  },
  {
    prop: 'package_status',
    label: '发布状态',
    filter: 'enum',
    filterOptions: {
      '': '未发布',
      unpublished: '未发布',
      run: '打包中',
      success: '成功',
      failure: '失败'
    }
  },
  // {
  //   prop: 'is_online',
  //   label: '课件上架状态',
  //   width: '148',
  //   filter: 'upShopBtn',
  //   filterOptions: {
  //     true: '已上架',
  //     false: '下架中'
  //   }
  // }, {
  //   prop: 'record_is_online',
  //   label: '录制课上架状态',
  //   width: '148',
  //   filter: 'upShopBtn',
  //   filterOptions: {
  //     true: '已上架',
  //     false: '下架中'
  //   }
  // }, {
  //   prop: 'type',
  //   label: '录制操作',
  //   width: '148',
  //   type: 'operation',
  //   typeOptions: [
  //     { key: 'record-list', value: '录制列表' },
  //     { key: 'preview-record', value: '预览录制' }
  //   ]
  // },
  {
    prop: 'practice',
    label: '练习操作'
  },
  {
    prop: 'operation',
    label: '课件操作',
    width: '180'
  }
]

export const tableData = [
  // {
//   date: '2016-05-02',
//   name: '王小虎',
//   address: '上海市普陀区金沙江路 1518 弄',
//   operation: [
//     { key: 'edit', value: '编辑' },
//     { key: 'preview', value: '预览' },
//     { key: 'create', value: '制作' },
//     { key: 'share', value: '分享课件' },
//     { key: 'delete', value: '删除文件' },
//     { key: 'copy', value: '复制课件' },
//     { key: 'move', value: '移动课件' },
//     { key: 'template', value: '设为模版' },
//     { key: 'practice', value: '关联学生练习' },
//     { key: 'census', value: '课件相关统计' }
//   ]
// }, {
//   date: '2016-05-04',
//   name: '王小虎',
//   address: '上海市普陀区金沙江路 1517 弄'
// }, {
//   date: '2016-05-01',
//   name: '王小虎',
//   address: '上海市普陀区金沙江路 1519 弄'
// }, {
//   date: '2016-05-03',
//   name: '王小虎',
//   address: '上海市普陀区金沙江路 1516 弄'
// }
]

export const fields = [
  {
    name: '请输入（文本）',
    value: '',
    type: 'Input',
    props: {
      placeholder: '请输入',
      rules: {
        required: true,
        message: '请输入',
        target: 'blur'
      }
    }
  }
]

export const tempFields = [
  {
    attr: 'name',
    name: '模版名称',
    value: '',
    type: 'Input',
    props: {
      placeholder: '请输入',
      rules: {
        required: true,
        message: '请输入',
        target: 'blur'
      }
    }
  },
  {
    attr: 'categoryId',
    name: '目录选择',
    value: [],
    type: 'Cascader',
    props: {
      placeholder: '请选择',
      rules: {
        required: false,
        message: '请选择'
      }
    },
    options: []
  }
]

export const orderFields = [
  {
    attr: 'order',
    name: '数量',
    value: 0,
    type: 'InputNumber',
    props: {
      placeholder: '请输入',
      rules: {
        required: true
      }
    }
  }
]

export const editInfoFields = [
  {
    attr: 'category_id_parent',
    name: '分类选择',
    value: '',
    type: 'Select',
    props: {
      placeholder: '请输入',
      rules: {
        required: true,
        message: '请输入',
        target: 'blur'
      }
    },
    options: []
  },
  {
    attr: 'category_id',
    name: '分类目录',
    value: [],
    type: 'Cascader',
    props: {
      placeholder: '请输入',
      rules: {
        required: true,
        message: '请输入'
      }
    },
    options: []
  },
  {
    attr: 'name',
    name: '课件名称',
    value: '',
    type: 'Input',
    props: {
      placeholder: '请输入',
      rules: {
        required: true,
        message: '请输入',
        target: 'blur'
      }
    }
  },
  {
    attr: 'title',
    name: '课件标题',
    value: '',
    type: 'Input',
    props: {
      placeholder: '请输入',
      rules: {
        required: true,
        message: '请输入',
        target: 'blur'
      }
    }
  },
  {
    attr: 'cover',
    name: '课件图片',
    value: '',
    type: 'SelectImage',
    props: {
      rules: {
        required: true,
        message: '请选择',
        target: 'blur'
      }
    },
    status: '1'
  },
  {
    attr: 'knowledge',
    name: '教学知识点',
    value: '',
    type: 'Input',
    props: {
      placeholder: '请输入',
      rules: {
        required: false,
        message: '请输入',
        target: 'blur'
      },
      type: 'textarea',
      rows: '2'
    }
  },
  {
    attr: 'desc',
    name: '内容/剧情介绍',
    value: '',
    type: 'Input',
    props: {
      placeholder: '请输入',
      rules: {
        required: false,
        message: '请输入',
        target: 'blur'
      },
      type: 'textarea',
      rows: '2'
    }
  }
]

export const subjectTempForm = [
  {
    attr: 'subject_id',
    "name": "学科",
    "value": "",
    "type": "Select",
    "props": {
      "placeholder": "请选择学科",
      "rules": {
        "required": true,
        "message": "请选择学科",
        "target": "blur"
      }
    },
    "options": []
  },
  {
    attr: 'category_id',
    "name": "分类",
    "value": [],
    "type": "Cascader",
    "props": {
      "placeholder": "请选择分类",
      "rules": {
        "required": true,
        "message": "请选择分类"
      }
    },
    "options": []
  }
]
